import React from 'react';
import { Layout } from '../components/Layout';

export const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  return (
    <Layout title="📊 Dashboard" subtitle={`Selamat datang, ${user.full_name || 'User'}`}>
      <div className="tg-card">
        <div className="tg-card-title">👤 Profil Anda</div>
        <div>Nama: {user.full_name}</div>
        <div>HP: {user.phone}</div>
        <div>Gender: {user.gender}</div>
        <div>Role: {user.role}</div>
        <div>Kode Referral: {user.referral_code}</div>
      </div>
    </Layout>
  );
};
